/**
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Slobodan Djordjevic, Brian Bal
 */
import * as localForage from 'localforage'

let defaultValue = {
    loading: false,
    complete: false,
    error: null,
    value: null
}

const loadStories = (teamName) => {
  return (dispatch, getState) => {
    let user = getState().user.value;
    let userComplete = getState().user.complete;
    let stories = getState().stories;

    if (stories.loading || stories.complete) {
      return {type: 'NOOP'}
    } else if (!userComplete) {
      return { type: 'NOOP' }
    }

    dispatch(setStories({ loading: true, error: null}))
    let userId = user ? user.user_id : '';

    localForage.getItem(`user_${userId}_team_${teamName}_stories`).then(function(stories) {
      if(stories?.length > 1) {
        let value = {
          loading: false,
          complete: true,
          value: stories,
          error: null
        }
        dispatch(setStories(value));
        let newStories = stories.filter((story, index) => index !== 0)

        saveToStorage(newStories, dispatch, teamName, userId)
      } else {
        fetchStories(teamName, dispatch, userId);
      }
    }).catch(function(err) {
      console.log('Error with setting local storage item: ', err);
    });
  }
}

export function setStories(value) {
    return function(dispatch) {
        dispatch({
            type: 'COMMON_SET',
            key: 'stories',
            value: value,
            defaultValue: {...defaultValue}
        })
    }
}

export function saveToStorage(data, dispatch, teamName, userId = '') {
    localForage.setItem(`user_${userId}_team_${teamName}_stories`, data).then(() => {
        let value = {
            loading: false,
            complete: true,
            value: data,
            error: null
        }
        dispatch(setStories(value))
    })
}

function fetchStories(teamName, dispatch, userId) {
    let userIdParam = userId ? '&user_id=' + userId : '';
    return fetch(`https://lapi.traceup.com/tracebot-${process.env.REACT_APP_TRACE_ENV}/stories/team?team_name=${teamName}${userIdParam}`, {
        method: 'GET',
        headers: {
            'Accept': 'application/json, text/plain, */*',
        }
    })
    .then(resp => {
      return resp.json()
    })
    .then(res => {
        if (res && res.success) {
            saveToStorage(res.data.stories, dispatch, teamName, userId);
        } else {
            console.log('Something went wrong');
            let value = {
                loading: false,
                complete: true,
                value: null,
                error: res.error
            }
            dispatch(setStories(value))

        }
    });
}

export default loadStories